import { useContext } from 'react'
import type { AppDispatch } from '@redux/store'

import { useRealtimeSubscription } from '@domain-group/react-hooks'

import RealtimeContext from '@contexts/realtimeContext'

import type { TaskListItemModel } from '@models/types'

import useDispatch from '@hooks/useDispatch'

import * as taskListItemActions from '@redux/modules/taskListItem'

type RealtimePayload = {
  filters: {
    task_list_id: number,
  },
  payload: TaskListItemModel,
}

type HydrateTaskListItemParams = {
  dispatch: AppDispatch,
  realtimePayload: RealtimePayload,
  taskListId: number,
}

const hydrateTaskListItem = (params: HydrateTaskListItemParams) => {
  const { hydrateTaskListItem: hydrateFn } = taskListItemActions
  const {
    dispatch,
    realtimePayload: {
      filters: {
        task_list_id,
      },
      payload,
    },
    taskListId,
  } = params

  if (taskListId === task_list_id){
    dispatch(hydrateFn(payload))
  }
}

type UseRealtimeTaskListItemsOptions = {
  taskListId: number,
}

function useRealtimeTaskListItems(options: UseRealtimeTaskListItemsOptions) {
  const { taskListId } = options

  const dispatch = useDispatch()

  const realtimeContext = useContext(RealtimeContext)
  // @ts-expect-error TS2339
  const { clientRef } = realtimeContext

  // New Tasks
  useRealtimeSubscription({
    apiKey: process.env.REACT_APP_ABLY_PUBLIC_KEY,
    callbacks: {
      success: (realtimePayload: RealtimePayload) => hydrateTaskListItem({
        dispatch,
        realtimePayload,
        taskListId,
      }),
    },
    channelName: 'taskListItems',
    clientRef,
    eventName: `taskList.${taskListId}.taskListItem.created`,
  }, [taskListId])

  // Updated Tasks
  useRealtimeSubscription({
    apiKey: process.env.REACT_APP_ABLY_PUBLIC_KEY,
    callbacks: {
      success: (realtimePayload: RealtimePayload) => hydrateTaskListItem({
        dispatch,
        realtimePayload,
        taskListId,
      }),
    },
    channelName: 'taskListItems',
    clientRef,
    eventName: `taskList.${taskListId}.taskListItem.updated`,
  }, [taskListId])
}

export default useRealtimeTaskListItems
